<div class="page-wrapper">
  <div class="change-password-card">
    <div class="card-header">
      <div class="lock-icon">&#128274;</div>
      <h1>Change Password Required</h1>
      <p>Your password was set by an administrator. You must set a new password before continuing.</p>
    </div>

    <div class="error-message" *ngIf="error">{{ error }}</div>

    <form (ngSubmit)="onSubmit()" #form="ngForm" autocomplete="off">
      <div class="form-group">
        <label>Current Password</label>
        <input
          type="password"
          [(ngModel)]="currentPassword"
          name="currentPassword"
          placeholder="Enter your current password"
          [disabled]="loading"
          autocomplete="current-password"
          required />
      </div>

      <div class="form-group">
        <label>New Password</label>
        <input
          type="password"
          [(ngModel)]="newPassword"
          name="newPassword"
          placeholder="Min. 8 characters"
          [disabled]="loading"
          autocomplete="new-password"
          required />
        <div class="requirements" *ngIf="newPassword">
          <span [class.met]="hasMinLength">&#10003; At least 8 characters</span>
        </div>
      </div>

      <div class="form-group">
        <label>Confirm New Password</label>
        <input
          type="password"
          [(ngModel)]="confirmPassword"
          name="confirmPassword"
          placeholder="Repeat new password"
          [disabled]="loading"
          autocomplete="new-password"
          required />
        <div class="requirements" *ngIf="confirmPassword">
          <span [class.met]="passwordsMatch">&#10003; Passwords match</span>
        </div>
      </div>

      <button type="submit" class="btn-submit" [disabled]="loading">
        <span *ngIf="!loading">Set New Password</span>
        <span *ngIf="loading">Saving...</span>
      </button>
    </form>
  </div>
</div>
